/* istanbul ignore file */
import { BaseBlock } from './BaseBlock';
import { BlockType } from '../BlockType';
import { BlockModuleType } from '../BlockModuleType';
import { BlockModuleState } from '../BlockModuleState';

export interface ReferenceItemModel {
  // FIXME: fix typing
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  local?: any;
  author?: string;
  date?: string;
  issue?: string;
  media?: string;
  page?: string;
  place?: string;
  publisher?: string;
  referenceType?: ReferenceType;
  referenceNumber?: string;
  title?: string;
  type?: string;
  reportNumber?: string;
  url?: string;
  doi?: string;
  editor?: string;
}

export enum ReferenceType {
  ARTICLE = 'article',
  BOOK = 'book',
  NEWSPAPER = 'newspaper',
  REPORT = 'report',
  DOCUMENT = 'document',
  WEBSITE = 'website',
  OTHER = 'other',
}

export interface ReferencesBlockModel extends BaseBlock {
  type: BlockType.REFERENCES;
  items: Array<ReferenceItemModel>;
  module__type?: BlockModuleType.MODULE | BlockModuleType.INLINE;
  state?: BlockModuleState;
  width?: string;
}
